import angular from 'angular';
import { receiveDisplayHelpFlag } from '../actions/page';
import { store } from '../store';

angular.module('FaqPageController', []).controller('FaqPageController', [
  '$scope',
  '$routeParams',
  ($scope, $routeParams) => {
    $scope.feature = $routeParams.feature;
    store.dispatch(receiveDisplayHelpFlag(false));
  },
]);
